import { create } from "zustand";

interface ReferralShareState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useReferralShare = create<ReferralShareState>()((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));

export const openReferralShare = () => useReferralShare.getState().setOpen(true);
